import {Badge} from '@mantine/core';
import {Text} from 'src/design/atoms/Text';
import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {SuperAdminResponse} from 'src/api/ProactApiClient';

export const useSuperAdminColumns = () => {
  const columns = useMemo<MRT_ColumnDef<SuperAdminResponse>[]>(
    () => [
      {
        accessorKey: 'email',
        header: 'Email',
        size: 280,
      },
      {
        id: 'primaryInstance',
        header: 'Primary Instance',
        accessorFn: row => row.primaryInstanceName ?? '',
        Cell: ({row}) =>
          row.original.primaryInstanceName ? (
            <Text size="sm">{row.original.primaryInstanceName}</Text>
          ) : (
            <Text size="sm" c="dimmed">
              —
            </Text>
          ),
      },
      {
        id: 'instanceProfiles',
        header: 'Instance Profiles',
        accessorFn: row => row.instanceMembershipCount,
        Cell: ({row}) =>
          row.original.hasInstanceMembership ? (
            <Badge color="green" variant="light">
              {row.original.instanceMembershipCount} profile
              {row.original.instanceMembershipCount !== 1 ? 's' : ''}
            </Badge>
          ) : (
            <Badge color="gray" variant="light">
              No profiles
            </Badge>
          ),
      },
      {
        id: 'createdAt',
        accessorFn: row => (row.createdAt ? new Date(row.createdAt) : null),
        filterVariant: 'date',
        header: 'Created',
        Cell: ({cell}) => (
          <>
            {cell.getValue<Date | null>()
              ? String(cell.getValue<Date>()).toShortDate()
              : ''}
          </>
        ),
      },
      {
        id: 'lastActiveAt',
        accessorFn: row =>
          row.lastActiveAt ? new Date(row.lastActiveAt) : null,
        filterVariant: 'date',
        header: 'Last Active',
        Cell: ({cell}) => (
          <>
            {cell.getValue<Date | null>()
              ? String(cell.getValue<Date>()).toShortDate()
              : ''}
          </>
        ),
      },
    ],
    []
  );

  return columns;
};
